<template>
  <modal :show.sync="modalsRol">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.users.headers.assignRole") }}
    </h4>
    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitSaveRole)">
        <dd class="col-sm-9">
          <dl class="row">
            <dt class="col-sm-4">{{ $t("app.modules.users.headers.name") }}</dt>
            <dd class="col-sm-8">
              {{ userRol.nombre }}
            </dd>
          </dl>
        </dd>
        <dd class="col-sm-9">
          <dl class="row">
            <dt class="col-sm-4">{{ $t("app.modules.users.headers.mail") }}</dt>
            <dd class="col-sm-8">
              {{ userRol.correo }}
            </dd>
          </dl>
        </dd>
        <el-select
          class="select-primary"
          size="large"
          placeholder="Selecciona rol"
          v-model="payload.roles_idrol"
        >
          <el-option
            v-for="rol in roles"
            class="select-primary"
            :value="rol.idRol"
            :label="rol.nombre"
            :key="rol.idRol"
          >
          </el-option>
        </el-select>
        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left" @click.native="cancelRol()">{{
            $t("app.buttons.cancel")
          }}</n-button>
          <n-button native-type="submit" type="primary">{{
            $t("app.buttons.save")
          }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      payload: {
        idRolUsuario: 0,
        roles_idrol: 0,
        usuarios_idUsuario: 0
      },
      roles: [],
      modalsRol: false,
      userRol: {}
    };
  },
  mounted() {
    EventBus.$on("asignar-rol", async user => {
      this.userRol = user;
      this.payload.usuarios_idUsuario = user.idUsuario;
      if (user.roles.length > 0) {
        this.payload.roles_idrol = user.roles[0].idRol;
        this.payload.idRolUsuario = user.roles[0].idRolUsuario;
      } else {
        this.selectedRol = 0;
        this.payload.roles_idrol = 0;
        this.payload.idRolUsuario = 0;
      }
      console.log(user);
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.iniAsignarRol();
      this.$swal.close();
      this.modalsRol = true;
    });
  },
  methods: {
    async submitSaveRole() {
      //Console
      console.log(this.payload);
      console.log("Guardar el rol y el usuario");
      await this.$http
        .post(route("Roles/postRolUsuario"), this.payload)
        .then(
          async response => {
            console.log(response);
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              EventBus.$emit("reload-items");
              this.modalsRol = false;
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    cancelRol() {
      this.modalsRol = false;
    },
    async iniAsignarRol() {
      var payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0
      };
      await this.$http
        .post(route("Roles/rolesVista"), payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.roles = response.body.roles;
              this.roles.push({
                idRol: 0,
                rol: "",
                empresa_idEmpresa: 0,
                activo: true,
                fechaRegistro: "",
                fechaEdicion: "",
                idRolTraduccion: 0,
                nombre: "Sin asignar",
                descripcion: "Sin asignar",
                idIdioma: 0,
                idioma: "",
                clave: ""
              });
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
